import React from "react";
import { Row, Col, Card, Empty } from "antd";
import VehicleMap from "./VehicleMap";

const DualVehicleMaps = ({ dayData, nightData, agencies, loading }) => {
  // Verificar si hay datos diurnos y nocturnos
  const hasDayData =
    dayData && (dayData.Pichincha?.length > 0 || dayData.Guayas?.length > 0);

  const hasNightData =
    nightData &&
    (nightData.Pichincha?.length > 0 || nightData.Guayas?.length > 0);

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12}>
        <Card
          title="Concentración de Vehículos - Diurno"
          style={{ height: "100%" }}
          loading={loading}
        >
          {hasDayData ? (
            <VehicleMap
              cantonStats={dayData}
              agencies={agencies}
              mapType="day"
              mapHeight="500px"
              showTitle={false}
            />
          ) : (
            <Empty description="No hay datos diurnos disponibles" />
          )}
        </Card>
      </Col>
      <Col xs={24} md={12}>
        <Card
          title="Concentración de Vehículos - Nocturno"
          style={{ height: "100%" }}
          loading={loading}
        >
          {hasNightData ? (
            <VehicleMap
              cantonStats={nightData}
              agencies={agencies}
              mapType="night"
              mapHeight="500px"
              showTitle={false}
            />
          ) : (
            <Empty description="No hay datos nocturnos disponibles" />
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default DualVehicleMaps;
